// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { ApplicationMenuItem } from "../../../components/ApplicationMenu";
import { jsx as _jsx } from "react/jsx-runtime";
export const MenuList = props => {
  const {
    name,
    libelle,
    icone,
    adresse,
    exact,
    offset,
    items
  } = props;
  return /*#__PURE__*/_jsx(ApplicationMenuItem, {
    name: name,
    path: adresse,
    content: libelle,
    icon: icone || "",
    exact: exact,
    offset: offset,
    items: items
    // disabled={!_.size(items)}
    ,
    popup: true,
    "data-sentry-element": "ApplicationMenuItem",
    "data-sentry-component": "MenuList",
    "data-sentry-source-file": "MenuList.tsx"
  });
};